class NBMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.closeDelay = 150; // ms delay before closing (allows tabbing into menu)
    this.closeTimeout = null;

    this.megamenuContainer = this.querySelector('.nb-megamenu-container');
    this.megamenuToggle = this.querySelector('.nb-megamenu-toggle');
    this.megamenu = this.querySelector('.nb-megamenu');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.addEventListener('focusin', this.onFocusIn.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  openMegamenu() {
    if (!this.megamenu || !this.megamenuToggle) return;

    // Cancel any pending close
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    this.megamenu.removeAttribute('hidden');
    this.megamenuToggle.setAttribute('aria-expanded', 'true');
  }

  closeMegamenu() {
    if (!this.megamenu || !this.megamenuToggle) return;

    this.megamenu.setAttribute('hidden', '');
    this.megamenuToggle.setAttribute('aria-expanded', 'false');
  }

  // Delayed close - allows user to move mouse/focus into menu
  scheduleClose() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }

    this.closeTimeout = setTimeout(() => {
      this.closeMegamenu();
      this.closeTimeout = null;
    }, this.closeDelay);
  }

  onMouseEnter() {
    this.openMegamenu();
  }

  onMouseLeave() {
    this.scheduleClose();
  }

  onFocusIn() {
    // Open when any element inside receives focus (toggle or menu items)
    this.openMegamenu();
  }

  onFocusOut(event) {
    // Check if focus is moving to another element within this component
    // relatedTarget is the element receiving focus
    if (event.relatedTarget && this.contains(event.relatedTarget)) {
      return; // Focus staying within component, keep open
    }

    this.scheduleClose();
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    if (this.megamenu && !this.megamenu.hasAttribute('hidden')) {
      // Cancel any pending close
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }

      this.closeMegamenu();

      // Return focus to the toggle
      if (this.megamenuToggle) {
        this.megamenuToggle.focus();
      }
    }
  }
}

customElements.define('nb-megamenu', NBMegaMenu);
